// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ImpersonationSessionView" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { Role } from "./role.enum.gen";

export const ImpersonationSessionViewGenShape = z.strictObject({
  id: z.string(),
  actorEmail: z.string().optional(),
  homeTeamId: z.string(),
  homeTeamName: z.string().optional(),
  targetTeamId: z.string(),
  targetTeamName: z.string().optional(),
  reason: z.string().optional(),
  effectiveRoles: z.array(z.enum(Role)).optional(),
  startedAt: z.string(),
  expiresAt: z.string(),
  endedAt: z.string().optional(),
  durationSeconds: z.number(),
});
